module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="control-group">\n    ';
 if(showLabel) {
__p+='\n    <label for="entity">Relates to</label>\n    ';
 } 
__p+='\n    <select id="entity" data-placeholder="'+
((__t=( placeholder ))==null?'':__t)+
'">\n        <option value=""></option>\n        ';
 _.each(items, function(item){ 
__p+='\n        <option value="'+
((__t=( item.id ))==null?'':__t)+
'" name="'+
((__t=( item.name ))==null?'':__t)+
'" ';
if (item.id == selectedEntityId) {
__p+=' selected ';
 } 
__p+=' >'+
((__t=( item.name ))==null?'':__t)+
'</option>\n        ';
 }) 
__p+='\n    </select>\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/entities/entities-select.html
// module id = 229
// module chunks = 0